module.exports = __webpack_public_path__ + "static/img/menu-pest_cockroach@2x.84d9bbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu-pest_cockroach@2x.png
// module id = 56
// module chunks = 0